// extracted by mini-css-extract-plugin
export var textInput = "_ht-0";